export default __webpack_public_path__ + "static/media/ZM.411155c7.svg";